import React from "react";

const IconOpenSidebar = () => {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.25" y="0.25" width="35.5" height="35.5" rx="11.75" stroke="#B2BCC6" strokeWidth="0.5"/>
<path d="M23.8333 10.5H12.1667C11.2462 10.5 10.5 11.2462 10.5 12.1667V23.8333C10.5 24.7538 11.2462 25.5 12.1667 25.5H23.8333C24.7538 25.5 25.5 24.7538 25.5 23.8333V12.1667C25.5 11.2462 24.7538 10.5 23.8333 10.5Z" stroke="#29394D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M15.5 10.5V25.5" stroke="#29394D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
  );
};

export default IconOpenSidebar;